import { NOOP } from '@vue/shared'
import Anchor from './src/anchor.vue'
import AnchorLink from './src/anchor-link.vue'

import type { App } from 'vue'
import type { SFCWithInstall } from '@element-plus/utils'

Anchor.install = (app: App): void => {
  app.component(Anchor.name, Anchor)
  app.component(AnchorLink.name, AnchorLink)
}

AnchorLink.install = NOOP

const _Anchor = Anchor as SFCWithInstall<typeof Anchor>
const _AnchorLink = AnchorLink as SFCWithInstall<typeof AnchorLink>

export default _Anchor

export const ElAnchor = _Anchor
export const ElAnchorLink = _AnchorLink

export * from './src/anchor'
export * from './src/anchor-link'
export type { AnchorInstance, AnchorLinkInstance } from './src/instances'
